(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-template"]) return;
  try {
    

$(document).ready(function () {
attachClickEvent();
});

var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
pInfScrNode = $('.more').last();	
pInfScrURL = $('.more a').last().attr("href");
if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
$.ajax({
type: 'GET',
url: pInfScrURL,
beforeSend: function() {
pInfScrLoading = true;
pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
pInfScrNode.hide();
},
success: function(data) {
// remove loading feedback
pInfScrNode.next().remove();
pInfScrNode.remove();
var filteredData = $(data).find(".collection-matrix");
filteredData.insertBefore( $("#product-list-foot") );					
pInfScrLoading = false;
/*$('li.singleproduct').setAllToMaxHeight();*/
attachClickEvent();
},
dataType: "html"
});

}
}

function attachClickEvent(){
$('.more a').click(function(event){
pInfScrExecute();
event.stopPropagation();
return false;
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template-2"]) return;
  try {
    

$(document).ready(function () {
attachClickEvent();
});

var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
pInfScrNode = $('.more').last();	
pInfScrURL = $('.more a').last().attr("href");
if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
$.ajax({
type: 'GET',
url: pInfScrURL,
beforeSend: function() {
pInfScrLoading = true;
pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
pInfScrNode.hide();
},
success: function(data) {
// remove loading feedback
pInfScrNode.next().remove();
pInfScrNode.remove();
var filteredData = $(data).find(".collection-matrix");
filteredData.insertBefore( $("#product-list-foot") );					
pInfScrLoading = false;
/*$('li.singleproduct').setAllToMaxHeight();*/
attachClickEvent();
},
dataType: "html"
});

}
}

function attachClickEvent(){
$('.more a').click(function(event){
pInfScrExecute();
event.stopPropagation();
return false;
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    

$(document).ready(function () {
attachClickEvent();
});

var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
pInfScrNode = $('.more').last();	
pInfScrURL = $('.more a').last().attr("href");
if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
$.ajax({
type: 'GET',
url: pInfScrURL,
beforeSend: function() {
pInfScrLoading = true;
pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
pInfScrNode.hide();
},
success: function(data) {
// remove loading feedback
pInfScrNode.next().remove();
pInfScrNode.remove();
var filteredData = $(data).find(".collection-matrix");
filteredData.insertBefore( $("#product-list-foot") );					
pInfScrLoading = false;
/*$('li.singleproduct').setAllToMaxHeight();*/
attachClickEvent();
},
dataType: "html"
});

}
}

function attachClickEvent(){
$('.more a').click(function(event){
pInfScrExecute();
event.stopPropagation();
return false;
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list-template"]) return;
  try {
    

$(document).ready(function () {
attachClickEvent();
});

var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
pInfScrNode = $('.more').last();	
pInfScrURL = $('.more a').last().attr("href");
if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
$.ajax({
type: 'GET',
url: pInfScrURL,
beforeSend: function() {
pInfScrLoading = true;
pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src="https://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791" />');
pInfScrNode.hide();
},
success: function(data) {
// remove loading feedback
pInfScrNode.next().remove();
pInfScrNode.remove();
var filteredData = $(data).find(".collection-matrix");
filteredData.insertBefore( $("#product-list-foot") );					
pInfScrLoading = false;
/*$('li.singleproduct').setAllToMaxHeight();*/
attachClickEvent();
},
dataType: "html"
});

}
}

function attachClickEvent(){
$('.more a').click(function(event){
pInfScrExecute();
event.stopPropagation();
return false;
});
}

  } catch(e) { console.error(e); }
})();
})();
